import { AfterViewInit, Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'app/shared/services/auth.service';
import { ReportDashboardService } from 'app/shared/services/reporting/report-dashboard.service';
import { DxDashboardControlComponent } from 'devexpress-dashboard-angular';
import { DeleteDashboardExtension } from './extensions/delete-dashboard-extension';
import { InputPopupComponent } from './input-popup/input-popup.component';
import { SaveAsDashboardExtension } from './extensions/save-as-dashboard-extension';
import { DefaultDashboardExtension } from './extensions/default-dashboard-extension';
import { DashboardPanelExtension } from 'devexpress-dashboard';

@Component({
  selector: 'app-report-dashboard',
  templateUrl: './report-dashboard.component.html',
  styleUrls: ['./report-dashboard.component.scss'],
})
export class ReportDashboardComponent implements OnInit, AfterViewInit {
  headers: { [key: string]: any } = {};
  workingMode: string = 'Viewer';
  isSysAdmin = false;
  isAdmin = false;
  refreshInterval: any;

  @ViewChild(DxDashboardControlComponent, { static: false })
  dashboardControl: DxDashboardControlComponent;
  @ViewChild(InputPopupComponent, { static: false })
  inputPopup: InputPopupComponent;
  panelExtension:DashboardPanelExtension;

  constructor(
    private authService: AuthService,
    private reportDashboardService: ReportDashboardService
  ) {
    this.headers = {
      Authorization: this.authService.getAuthorizationHeaderValue(),
    };

    this.isSysAdmin = this.authService.hasPriv('sysadmin');

    // Admins can create BI Dashboards, Users can only view them
    this.isAdmin = this.authService.hasPriv('admin');
    if (this.isAdmin)
      this.workingMode="Designer";    
    else 
      this.workingMode="Viewer";    
  }
  ngOnInit(): void {
    const self = this;    
    this.refreshInterval = setInterval(() => {
      this.headers = { Authorization: self.authService.getAuthorizationHeaderValue() };
    }, 5000);
  }

  ngAfterViewInit(): void {
    this.dashboardControl.instance.registerExtension(
      new SaveAsDashboardExtension(
        this.dashboardControl.instance,
        this.inputPopup
      )
    );
    this.dashboardControl.instance.registerExtension(
      new DeleteDashboardExtension(
        this.dashboardControl.instance,
        this.reportDashboardService
      )
    );

    this.dashboardControl.instance.registerExtension(
      new DefaultDashboardExtension(
        this.dashboardControl.instance,
        this.reportDashboardService
      )
    );

    // Add Side Panel
    this.panelExtension = new DashboardPanelExtension(this.dashboardControl.instance);
    this.dashboardControl.instance.registerExtension(this.panelExtension);
    this.panelExtension.allowSwitchToDesigner(this.isAdmin || this.isSysAdmin);
  }

  // showDashboardPanel() {
  //   // The dashboardControl variable is the obtained DashboardControl instance.    
  //   this.panelExtension.showPanelAsync({}).done(function (e) {
  //     this.dashboardControl.instance.surfaceLeft(e.surfaceLeft);
  //   });
  // }

  get workingModeText() {
    return 'Switch to ' + this.toggleMode(this.workingMode);
  }

  changeWorkingMode() {
    this.workingMode = this.toggleMode(this.workingMode);
  }

  toggleMode(mode) {
    return mode === 'Viewer' ? 'Designer' : 'Viewer';
  }
}
